import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="Footer">
      <div className="Footer-inner">
        <p className="Footer-brand">Harteis Physical Therapy &amp; Sports Performance</p>
        <div className="Footer-links">
          <a href="mailto:harteispt@gmail.com">harteispt@gmail.com</a>
          <span className="dot">&bull;</span>
          <a href="tel:+18145259768">(814) 525-9768</a>
        </div>
        <p className="Footer-copy">&copy; {new Date().getFullYear()} Harteis Physical Therapy &amp; Training</p>
      </div>
    </footer>
  );
}
